export type PositionType = 'first' | 'last' | 'only' | 'standard';

export function getPositionType({
	index,
	listSize,
}: {
	index: number;
	listSize: number;
}): PositionType {
	if (listSize <= 1) {
		return 'only';
	}
	if (index === 0) {
		return 'first';
	}
	if (index === listSize - 1) {
		return 'last';
	}
	return 'standard';
}
